export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0057.e9e1a62e.webp";